<template>
  <div class="white d-flex flex-column crane-copyright-page-height">
    
     <div class="container-grid my-10 px-6">
      <h1 class="mt-10 mb-6 font-weight-medium">Copyright & Trademark</h1>
      <p
        class="fontcolor-black-light my-6"
      >(c) Copyright 2025 Decree-Crane Special Papers N.A., LLC (Crane) - All rights reserved <br>
 
<br>
Decree-Crane Special Papers N.A., LLC (Crane) is not affiliated, endorsed by or under shared ownership control of Fedragoni Special Papers N.A. Inc. (Fedragoni) nor does it produce any of the products or services on this website. Crane is granted a license to the Licensed Marks by Fedragoni solely with respect to the Licensed Products.<br> <a href="https://fedrigoni.com/en/" target="blank">fedrigoni.com/en/</a>  </p>
    </div>

       
   
    <v-row class="d-flex align-end">
      <FooterComponent />
    </v-row>
  </div>
</template>
<script>
const baseUrl = import.meta.env.VITE_BASE_URL;
import FooterComponent from "@/components/layout/footer/FooterComponent.vue";
export default {
  name: "copyright",
  data() {
    return {};
  },
  components: {
    FooterComponent
  },
  watch: {},
  computed: {
    
      canonical: function() {
      return this.$route.meta.canonical;
    }, 
  },
   metaInfo() {
        return {
           
            link: [
                {rel: 'canonical', href:`${this.canonical ? window.location.href.split('?')[0] : baseUrl }`}
            ] 
        }
  },
  
};
</script>
<style  lang="scss">
.crane-copyright-page-height{
    height: -webkit-fill-available;
}
@media (min-width: 1264px)
{
  .container-grid {
    max-width: 1185px;
}
}
.container-grid{
    width: 100%;
    padding: 12px;
    margin-right: auto;
    margin-left: auto;
}
</style>